import React, { useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import { useAuth } from '../components/auth/AuthProvider';

interface ProtectedRouteProps {
  children: React.ReactNode;
  requireAdmin?: boolean;
}

/**
 * ProtectedRoute 组件
 * 路由守卫，保护需要认证的页面
 *
 * @example
 * ```tsx
 * <ProtectedRoute>
 *   <DevAdminView />
 * </ProtectedRoute>
 * ```
 */
export function ProtectedRoute({ children, requireAdmin = false }: ProtectedRouteProps) {
  const { isAuthenticated, isLoading, user } = useAuth();
  const navigate = useNavigate();

  useEffect(() => {
    if (isLoading) {
      return;
    }

    if (!isAuthenticated) {
      navigate('/', { replace: true });
      return;
    }

    if (requireAdmin && !user?.isAdmin) {
      navigate('/profile', { replace: true });
    }
  }, [isAuthenticated, isLoading, navigate, requireAdmin, user?.isAdmin]);

  if (isLoading) {
    return null;
  }

  return isAuthenticated && (!requireAdmin || user?.isAdmin) ? <>{children}</> : null;
}
